export default {"src":"/_next/static/media/dark-grey-right.3c1286aa.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};